import React, { useEffect, Fragment } from 'react'
import { NotificationsOutline } from 'react-ionicons'
import { 
  DropdownToggle, DropdownMenu,
  Nav, NavItem,
  Button, 
  UncontrolledButtonDropdown 
} from 'reactstrap'
import { connect } from 'react-redux'
import { getNotification } from 'actions/notifications'

const Notification = ({
  data,
  notification,
  history,
  setNotificationRead,
  getNotification,
  onToggleDetail,
  onChangeSelected
}) => {
  const { current_role_id } = data.ProfileReducer

  useEffect(() => {
    if (current_role_id) {
      getNotification( btoa(`{ "page": 1, "per_page": 5, "filter": { "is_read": true }}`), false, current_role_id )
    }
  }, [current_role_id])
  

  return (
    <UncontrolledButtonDropdown>
      <DropdownToggle color="link">
        <div 
          className="icon-wrapper bg-warning icon-wrapper-alt rounded-circle" 
          style={{ width: 'initial', height: 'initial', padding: 8, overflow: 'initial' }}
        >
          <NotificationsOutline width={ '25px' } color="white"/>
          {
            notification.meta.unread_count > 0 && (
              <div 
                className="badge badge-dot badge-dot-sm badge-warning"
              >
                Notifications
              </div>
            )
          }
        </div>
      </DropdownToggle>
      <DropdownMenu 
        right 
        className="dropdown-menu-xl rm-pointers" 
        style={{
          maxHeight: '240px',
          overflowY: 'auto',
          overflowX: 'hidden'
        }}>
          <div className="dropdown-menu-header mb-0">
              <div className="dropdown-menu-header-inner" style={{ padding: '0.8rem 0.5rem' }}>
                  <div className="menu-header-content text-dark">
                      <h5 className="menu-header-title">
                        { `Notifications` }
                      </h5>
                  </div>
              </div>
          </div>
          <Nav vertical>
          {
            notification.meta.Meta.total_count < 1 && (
              <>
              <NavItem className="nav-item-divider"/>
              <NavItem className="text-center">
                <h6 className={ 'fw-600' }>No notification is available.</h6>
                </NavItem>
              </>
            )
          }
          {
            notification.meta.Meta.total_count > 0 && (
              <>
                {
                  notification.data?.[0] && notification.data.map( data => (
                    (
                      <Fragment key={ data.id }>
                        <NavItem className="nav-item-divider"/>
                        <NavItem 
                          className="nav-item-btn position-relative"
                          style={{ cursor: 'pointer' }}
                          onClick={ () => {
                            onChangeSelected( data )
                            onToggleDetail( true )
                            !data.is_read && setNotificationRead( data.id, current_role_id )
                          }}
                        >
                          <span>
                            { `${ data.content.slice( 0, 150 ) } ${ data.content.length > 150 ? '...' : '' }`}
                          </span>
                          {
                            !data.is_read && (
                              <div 
                                className="badge badge-dot badge-dot-lg badge-warning position-absolute"
                                style={{ top: '40%', right: 10, backgroundColor: '#545cd8' }}
                              >
                                Unread
                              </div>
                            )
                          }
                        </NavItem>
                      </Fragment>
                    )
                  ))
                }
              </>
            )
          }
          <NavItem className="nav-item-divider"/>
            <NavItem className="nav-item-btn text-center">
                <Button 
                  size="sm" className="btn-shadow btn-wide btn-pill" color="focus"
                  style={{ padding: '4px 8px' }}
                  onClick={ () => history.push( '/dashboard/notifications' )}
                >
                    View All Notification
                </Button>
            </NavItem>
        </Nav>
      </DropdownMenu>
    </UncontrolledButtonDropdown>
  )
}

const mapStateToProps = state => ({ data: state })
export default connect( mapStateToProps,{
  getNotification
})( Notification );
